export default [
  {
    host: 'default',
    params: {

      // baseUrl: 'https://cloud.xuniplay.com/services',
      // findandbookService: '/findandbookService',
      // statsService: '/wh-stats',
      // pmfBaseUrl: 'https://cloud.xuniplay.com/Services',
      // academyBaseUrl: "https://cloud.xuniplay.com/Services/AcademyFEService",
      // pmfService: '/PmfService',
      // webAppUrl: 'https://webportal.workhera.com/expiration.html',

      baseUrl: 'https://dev.workhera.com/services',
      findandbookService: '/findandbookService',
      academyBaseUrl: "https://dev.xuniplay4.fabbricadigitale.it/Services/AcademyFEService",
      statsService: '/wh-stats',
      pmfBaseUrl: 'https://dev.xuniplay4.fabbricadigitale.it/Services',
      pmfService: '/PmfService',
      webAppUrl: 'https://dev.workhera.com/webportal/expiration.html',

      userLanguageCookieKey: 'userSettings',
      devices: [
        {
          name: 'monitor',
          icon: 'icon-we2_monitor',
        },
        {
          name: 'speaker',
          icon: 'icon-we2_cassa',
        },
        {
          name: 'camera',
          icon: 'icon-we2_camera',
        },
        {
          name: 'microphone',
          icon: 'icon-we2_microphone',
        },
        {
          name: 'videoconference',
          icon: 'icon-we2_conference',
        },
        {
          name: 'ethernet',
          icon: 'icon-we2_ethernet2',
        },
        {
          name: 'lamp',
          icon: 'icon-we2_light',
        },
      ],
    },
  },
  {
    host: 'dev.workhera.com',
    params: {
      /* "baseUrl": 'https://cloud.xuniplay.com/services',
      "findandbookService": '/findandbookService',
      "statsService": '/wh-stats',
      "pmfBaseUrl": 'https://cloud.xuniplay.com/Services',
      "pmfService": '/PmfService',
      "webAppUrl": 'https://webportal.workhera.com/expiration.html', */

      "baseUrl": "https://dev.workhera.com/services",
      "findandbookService": "/findandbookService",
      "academyBaseUrl": "https://dev.xuniplay4.fabbricadigitale.it/Services/AcademyFEService",
      "statsService": "/wh-stats",
      "pmfBaseUrl": "https://dev.xuniplay4.fabbricadigitale.it/Services",
      "pmfService":"/PmfService",
      "webAppUrl": "https://dev.workhera.com/webportal/expiration.html",


      userLanguageCookieKey: 'userSettings',
      devices: [
        {
          name: 'monitor',
          icon: 'icon-we2_monitor',
        },
        {
          name: 'speaker',
          icon: 'icon-we2_cassa',
        },
        {
          name: 'camera',
          icon: 'icon-we2_camera',
        },
        {
          name: 'microphone',
          icon: 'icon-we2_microphone',
        },
        {
          name: 'videoconference',
          icon: 'icon-we2_conference',
        },
        {
          name: 'ethernet',
          icon: 'icon-we2_ethernet2',
        },
        {
          name: 'lamp',
          icon: 'icon-we2_light',
        },
      ],
    },
  },
  {
    host: 'cloud.workhera.com',
    params: {
      baseUrl: 'https://cloud.xuniplay.com/services',
      findandbookService: '/findandbookService',
      statsService: '/wh-stats',
      pmfBaseUrl: 'https://cloud.xuniplay.com/Services',
      academyBaseUrl: "https://cloud.xuniplay.com/Services/AcademyFEService",
      pmfService: '/PmfService',
      webAppUrl: 'https://webportal.workhera.com/expiration.html',
      userLanguageCookieKey: 'userSettings',
      devices: [
        {
          name: 'monitor',
          icon: 'icon-we2_monitor',
        },
        {
          name: 'speaker',
          icon: 'icon-we2_cassa',
        },
        {
          name: 'camera',
          icon: 'icon-we2_camera',
        },
        {
          name: 'microphone',
          icon: 'icon-we2_microphone',
        },
        {
          name: 'videoconference',
          icon: 'icon-we2_conference',
        },
        {
          name: 'ethernet',
          icon: 'icon-we2_ethernet2',
        },
        {
          name: 'lamp',
          icon: 'icon-we2_light',
        },
      ],
      customDevices: {
        //ItaliaOnline prod MobileCode: 4364ec6d-c728-4045-8828-17b329890cc6
        desk: {
          '4364ec6d-c728-4045-8828-17b329890cc6': [
            {
              name: 'standardWorkspace',
              icon: 'icon-we2_monitor',
            },
            {
              name: 'graphicsWorkspace',
              icon: 'icon-we2_panoramic-view',
            },
            {
              name: 'designatedWorkspace',
              icon: 'icon-we1_desk1',
            },
          ],
        },
        room: {
          '4364ec6d-c728-4045-8828-17b329890cc6': [
            {
              name: 'monitor',
              icon: 'icon-we2_monitor',
            },
            {
              name: 'speaker',
              icon: 'icon-we2_cassa',
            },
            {
              name: 'camera',
              icon: 'icon-we2_camera',
            },
            {
              name: 'mic',
              icon: 'icon-we2_microphone',
            },
            {
              name: 'videoconf',
              icon: 'icon-we2_conference',
            },
            {
              name: 'ethernet',
              icon: 'icon-we2_ethernet',
            },
          ],
        },
      },
      filtersJustOpened: ['4364ec6d-c728-4045-8828-17b329890cc6'],
    },
  },
];
